module.exports = __webpack_public_path__ + "static/media/YB5F12_7.75a05c82.jpg";